import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpEvent, HttpRequest } from '@angular/common/http';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { PatentDraftDataForm } from '../_models/patent-draft-data-form';
import { Observable } from 'rxjs';

@Injectable()
export class PatentDraftService {


  constructor(private http: HttpClient, private authService : AuthService) { }

  public static readonly URL_PROJECT_CONTROLLER = environment.apiUrl + '/patentDraft/';
  // Project URL Set UP
  public static readonly URL_GET_PATENTDRAFT_LIST = PatentDraftService.URL_PROJECT_CONTROLLER + "getAll/";
  public static readonly URL_GET_PATENT_BY_ID = PatentDraftService.URL_PROJECT_CONTROLLER + "getById/";
  public static readonly URL_SAVEANDUPDATE_PATENTDRAFT = PatentDraftService.URL_PROJECT_CONTROLLER + "saveUpdate/";
  public static readonly URL_DELETE_PATENTDRAFT = PatentDraftService.URL_PROJECT_CONTROLLER + "delete/"
  public static readonly URL_GENERATEPDF_PATENTDRAFT = PatentDraftService.URL_PROJECT_CONTROLLER + "generatePatentPdf/";
  public static readonly URL_GET_PATENT_BY_PROJECt_ID = PatentDraftService.URL_PROJECT_CONTROLLER + "getByProjectId/";

   // Patent Draft
   getPatentDraftList() {
    let userToken: string = this.authService.getUserToken();
    return this.http.get(PatentDraftService.URL_GET_PATENTDRAFT_LIST + "/" + userToken)
    // .pipe(map((response: Response) => response.json()));
    .pipe(catchError(this.handleError('Request Failed')));
  }

  saveAndUpdateProject(patentDraftDataForm: PatentDraftDataForm) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(PatentDraftService.URL_SAVEANDUPDATE_PATENTDRAFT + userToken,patentDraftDataForm)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  getPatentDraftById(id) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(PatentDraftService.URL_GET_PATENT_BY_ID +id + '/'+userToken,id)
      .pipe(catchError(this.handleError('Request Failed')));
  }
  
  getPatentDraftByProjectId(projectId) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(PatentDraftService.URL_GET_PATENT_BY_PROJECt_ID +projectId + '/'+userToken,projectId)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  deleteProject(patentDraftDataForm: PatentDraftDataForm) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(PatentDraftService.URL_DELETE_PATENTDRAFT + userToken, patentDraftDataForm)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  generatePatentDraftPDF(id) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(PatentDraftService.URL_GENERATEPDF_PATENTDRAFT + userToken,id)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse) => {
      console.log(error);
      if (error.status === 401) {
        localStorage.removeItem('currentUser');
        window.location.replace('');
      }
      return Observable.throw(error);
    };
  }


}
